{
  "contributionRebalance": "Commencer un nouveau rééquilibrage des cotisations",
  "driftRebalance": "Commencer un nouveau rééquilibrage de la dérive",
  "table": {
    "createdAt": "Exécuté à",
    "state": "État",
    "files": "Fichiers",
    "organization": "Organisation"
  },
  "buyTradeFile": "Achats en gros",
  "sellTradeFile": "Vente en vrac",
  "mutualFundTradeFile": "Négociations de fonds communs de placement",
  "allocationFile": "Allocations",
  "ptfBulkTradeFile": "Fichier des opérations groupées PTF"
}
